import { DatePicker } from "@/features/projects/filter/dateFilter/DatePicker";
import {
  type DateFilterOption,
  dateUpdateAction,
} from "@/features/projects/filter/dateFilter/utils";
import { type FilterItemsProps } from "@/features/projects/filter/type";
import { useState } from "react";
import { useUnmount } from "usehooks-ts";

type CreatedDateFilterPillProps = FilterItemsProps & {
  option: DateFilterOption;
};

export const DateFilterPill = ({
  actions,
  filters,
  option,
}: CreatedDateFilterPillProps) => {
  const [dateRange, setDateRange] = useState(filters.createdDate ?? []);

  useUnmount(() => {
    dateUpdateAction(dateRange, actions, option);
  });

  return <DatePicker onChange={setDateRange} createdDate={dateRange} />;
};
